import { User } from "../../../../shared/models/user/user";
import { useAppSelector } from "../../../../../redux/store";
import {
  Message,
  MessageSections,
} from "../../../../components/message/message";
import BarekamText from "../../../../components/text";
import { Grid, Skeleton } from "@mui/material";
import BarekamInput from "../../../../components/input";
import BarekamPhoneInput from "../../../../auth/phone-input/phone-input";
import { UserDisabledInputsContainer, UserPasswordContainer } from "./styled";
import BarekamButton, { SimpleButtons } from "../../../../components/button";
import { getMessage } from "../../../../shared/helper-functions";

export const UserInputs = ({
  userData,
  onChange,
  errors,
  onPasswordChange,
}: UserInputsProps) => {
  const { messageCache, languageId } = useAppSelector(
    (state) => state.messagesReducer,
  );

  if (userData) {
    return (
      <>
        <Grid item xs={12}>
          <UserDisabledInputsContainer>
            <BarekamText variant={"s"} opaque>
              <Message
                messageKey={"user_settings_email"}
                sectionId={MessageSections.USER}
              />
            </BarekamText>

            <BarekamText variant={"s"} fontWeight={500}>
              {userData.email}
            </BarekamText>
          </UserDisabledInputsContainer>
        </Grid>
        {!userData?.isSocial && (
          <Grid item xs={12}>
            <UserDisabledInputsContainer>
              <BarekamText variant={"s"} opaque>
                <Message
                  messageKey={"user_settings_password"}
                  sectionId={MessageSections.USER}
                />
              </BarekamText>

              <UserPasswordContainer>
                <BarekamText variant={"s"} fontWeight={500}>
                  ********
                </BarekamText>

                <BarekamButton
                  type={SimpleButtons.TEXT}
                  onClick={onPasswordChange}
                >
                  <BarekamText variant={"m"}>
                    <Message
                      messageKey={"user_settings_edit_password"}
                      sectionId={MessageSections.USER}
                    />
                  </BarekamText>
                </BarekamButton>
              </UserPasswordContainer>
            </UserDisabledInputsContainer>
          </Grid>
        )}

        <Grid item xs={12}>
          <BarekamInput
            key={"user-settings-first-name"}
            customInputVariant={"standard"}
            placeholder={getMessage(
              "user_settings_first_name",
              MessageSections.USER,
              messageCache,
              languageId,
            )}
            value={userData.firstName}
            onChange={(value) => onChange(value.target.value, "firstName")}
            type={"text"}
            error={!!errors["firstName"]}
            errorMessage={
              errors["firstName"] &&
              getMessage(
                errors["firstName"],
                MessageSections.USER,
                messageCache,
                languageId,
              )
            }
            width={"100%"}
            required
            validatePattern
          />
        </Grid>

        <Grid item xs={12}>
          <BarekamInput
            key={"user-settings-last-name"}
            customInputVariant={"standard"}
            placeholder={getMessage(
              "user_settings_last_name",
              MessageSections.USER,
              messageCache,
              languageId,
            )}
            value={userData.lastName}
            onChange={(value) => onChange(value.target.value, "lastName")}
            type={"text"}
            error={!!errors["lastName"]}
            errorMessage={
              errors["lastName"] &&
              getMessage(
                errors["lastName"],
                MessageSections.USER,
                messageCache,
                languageId,
              )
            }
            width={"100%"}
            required
            validatePattern
          />
        </Grid>

        <Grid item xs={12}>
          <BarekamPhoneInput
            key={"user-settings-phone-number"}
            value={userData.phoneNumber}
            placeholder={getMessage(
              "user_settings_phone_number",
              MessageSections.USER,
              messageCache,
              languageId,
            )}
            width={"100%"}
            onChange={(value: number) => onChange(value, "phoneNumber")}
          />
        </Grid>

        {userData?.entityName && (
          <>
            <Grid item xs={6}>
              <BarekamInput
                key={"user-settings-entity-name"}
                customInputVariant={"standard"}
                value={userData.entityName}
                placeholder={getMessage(
                  "user_settings_entity_name",
                  MessageSections.USER,
                  messageCache,
                  languageId,
                )}
                width={"100%"}
                onChange={(value) => onChange(value.target.value, "entityName")}
                validatePattern
              />
            </Grid>
            <Grid item xs={6}>
              <BarekamInput
                key={"user-settings-tid"}
                value={userData?.tid}
                customInputVariant={"standard"}
                placeholder={getMessage(
                  "user_settings_tid",
                  MessageSections.USER,
                  messageCache,
                  languageId,
                )}
                width={"100%"}
                onChange={(value) => onChange(value.target.value, "tid")}
              />
            </Grid>
          </>
        )}
      </>
    );
  } else {
    return (
      <>
        <Skeleton width={"50%"} height={"5.5rem"}></Skeleton>

        <Skeleton width={"50%"} height={"5.5rem"}></Skeleton>

        <Skeleton width={"50%"} height={"5.5rem"}></Skeleton>
      </>
    );
  }
};

interface UserInputsProps {
  userData?: User;
  onChange: (value: any, field: string) => void;
  onPasswordChange: () => void;
  errors: { [key: string]: string };
}
